<div class="paywall-container">
  <div
    class="header d-flex align-items-center justify-content-space-between slide-from-top debug-header"
  >
    <div class="header-text d-flex flex-column justify-content-space-between h-100">
      @if (timer) {
        <div class="header-title">
          {{ discountTitle }} <ng-container i18n="@@discount">discount</ng-container>
        </div>
      }
      @if (timer) {
        <div>
          <ng-container i18n="@@isReservedFor">is reserved for:</ng-container>
        </div>
      }
      @if (!timer) {
        <div class="header-title" i18n="@@savedYourDiscount">
          We saved your {{ discountTitle }} discount!
        </div>
      }
    </div>
    <div class="d-flex align-items-center gap-16">
      @if (timer) {
        <div class="header-timer fw-semibold">{{ timer }}</div>
      }
      <button mat-flat-button class="tagus" (click)="topButtonClicked()">
        {{ purchaseButtonTitle }}
      </button>
    </div>
  </div>

  @if (!isStrictPaywall) {
    <h1 class="display-6 mt-32 w-100" [innerHTML]="title" [@fadeAnimation]></h1>
  }

  @if (!isStrictPaywall) {
    <div class="growth-container mt-20 w-100 border-radius" [@fadeAnimation]>
      <div class="growth-header">{{ contextTitle }}</div>
      <div class="d-flex">
        <div class="now-container">
          <div class="time-label" i18n="@@now">Now</div>
          <canvas height="480" width="640" #beforeAnimation class="w-100"></canvas>
          <div class="comparison-text d-flex align-items-center flex-grow-1 mt-10">
            <span>{{ beforeText }}</span>
          </div>
        </div>
        <div class="future-container">
          <div class="time-label" i18n="@@in3Months">In 3 months</div>
          <canvas height="480" width="640" #afterAnimation class="w-100"></canvas>
          <div class="comparison-text d-flex align-items-center main-color flex-grow-1">
            <span>{{ afterText }}</span>
          </div>
        </div>
      </div>
      <div class="social-proof-container d-flex flex-column gap-8 align-items-center">
        <div class="social-proof-text">{{ socialProofText }}</div>
        <div class="social-proof-users-container">
          <div class="social-proof-users-scroll">
            @for (user of recentUsers; track trackByUserId($index, user)) {
              <div class="social-proof-user" [attr.data-user-id]="user.id">
                {{ user.name }} <ng-container i18n="@@joined">joined</ng-container>
                {{ user.timeAgo }}
              </div>
            }
          </div>
        </div>
        <div class="fs-14 mt-5" i18n="@@planIsReserved">Your personalized plan is reserved</div>
        <p class="text-center fs-12" i18n="@@planReserved10Min">
          We've reserved your personalized plan for 10 minutes. Don't miss out!
        </p>
      </div>
    </div>
  }

  <h4 class="mt-20" [ngClass]="{ 'mt-32': isStrictPaywall }" [@fadeAnimation]>
    {{ planCta }}
  </h4>

  @if (!isStrictPaywall) {
    <div
      class="gift-box col-12 border-radius d-flex align-items-center"
      [ngClass]="{
        'bg-main-color': placement === placements.main,
        'bg-orange-color': placement === placements.discount,
      }"
      (click)="payButtonClicked()"
      [@fadeAnimation]
    >
      <div class="gift-icon"></div>
      @if (placement === placements.discount) {
        <div class="gift-label">
          <ng-container i18n="@@paywallGiftLabelDiscountPrefix"
            >Get your personal plan with a</ng-container
          >
          <span>{{ ' ' }}</span>
          <span class="crossed greyed">{{ initialDiscountTitle }}</span>
          <span>{{ ' ' }}</span>
          <ng-container i18n="@@paywallGiftLabelDiscountSuffix"
            >{{ discountTitle }} discount</ng-container
          >
        </div>
      }
      @if (placement === placements.main) {
        <div class="gift-label">
          @if (timer) {
            <div>
              {{ discountTitle }} <span class="fw-normal">{{ discountReservedLabel }}</span>
              <span> {{ timer }}</span>
            </div>
          }
          @if (!timer) {
            <div i18n="@@paywallGiftLabelSaved">We saved your {{ discountTitle }} discount!</div>
          }
        </div>
      }
    </div>
  }

  <div class="col-12 mt-24" #topCheckout>
    <app-checkout
      [(selectedProduct)]="selectedProduct"
      #checkout
      [placement]="placement"
      [email]="email"
      [name]="name"
      [isDisclaimerShown]="false"
      [stripeCustomerId]="stripeCustomerId"
      [moneyBackGuaranteeMode]="'small'"
      [insufficientFundsAction]="getInsufficientFundsAction()"
      (canceledPurchase)="onPurchaseCanceled()"
      (purchaseButtonTitle)="handlePurchaseButtonTitle($event)"
      (discountTitle)="handleDiscountTitle($event)"
    >
    </app-checkout>
  </div>

  <div class="mt-32 text-list w-100 row">
    <h3 class="section">
      <ng-container i18n="@@highlightsTitle">Highlights of your personalized plan:</ng-container>
    </h3>
    @for (highlight of highlights; track highlight) {
      <div>{{ highlight }}</div>
    }
  </div>

  @if (isCompetitorInfoShown && comparisonRows.length > 0) {
    <div class="w-100 mt-32 row" [@fadeAnimation]>
      <div class="col-12">
        <h3 [innerHTML]="comparisonTitle"></h3>
      </div>
      <div class="comparison-table w-100 mt-20">
        @for (r of comparisonRows; track r) {
          <div class="cmp-row">
            <div class="cmp-cell feature">{{ r.feature }}</div>
            <div class="cmp-cell icons">
              @if (r.peech) {
                <i class="ri-check-line main-color"></i>
              }
              @if (!r.peech) {
                <i class="ri-close-line red-color"></i>
              }
            </div>
            <div class="cmp-cell icons">
              @if (r.opponent) {
                <i class="ri-check-line main-color"></i>
              }
              @if (!r.opponent) {
                <i class="ri-close-line red-color"></i>
              }
            </div>
          </div>
        }
      </div>
      @if (comparisonFootnote) {
        <div class="mt-20 fs-14 muted-color">
          {{ comparisonFootnote }}
        </div>
      }
    </div>
  }

  <div class="row align-items-center mt-32 w-100">
    <div class="col-12">
      <h2 class="display-6">
        <ng-container i18n="@@whatYouGetPrefix">What you get with</ng-container>
        <span class="main-color"> Peech</span>
      </h2>
    </div>
    <div class="d-flex flex-column justify-content-center col-12 gap-16 mt-20">
      @for (feature of features; track feature.title) {
        <div class="stat d-flex align-items-center">
          <div class="stats-emoji">{{ feature.emoji }}</div>
          <div class="d-flex flex-column">
            <div class="stats-title fs-18">{{ feature.title }}</div>
            <div class="stats-text">{{ feature.description }}</div>
          </div>
        </div>
      }
    </div>
    <div class="d-flex justify-content-center mt-32">
      <video autoplay muted loop playsinline poster="/assets/img/formats.png">
        <source src="/assets/video/PC_Voice_Change-safari.mp4" type='video/mp4; codecs="hvc1"' />
        <source src="/assets/video/PC_Voice_Change-chrome.webm" type="video/webm" />
      </video>
    </div>
  </div>

  <h1 class="display-6 mt-16 w-100">
    <ng-container i18n="@@justHitPlayTryPrefix">Just Hit</ng-container>
    <span class="ri-play-fill main-color"></span>
    <ng-container i18n="@@justHitPlayTrySuffix">to Try</ng-container>
  </h1>

  <div class="row align-items-center w-100">
    <div class="col-12 d-flex flex-column gap-16">
      <!-- <h5 class="display-6">Just Hit <span class="ri-play-fill main-color"></span> to Try</h5> -->
      @for (section of audioTrackSections; track section.title) {
        <div class="fs-20" [ngClass]="{ 'mt-5': !$first }">{{ section.title }}</div>
        @for (track of section.tracks; track track) {
          <app-audio-track
            #audioTrackRef
            (onPlayed)="onPlay($event)"
            [data]="track"
          ></app-audio-track>
        }
      }
    </div>
  </div>

  <!-- <div class="row mt-32">
  <h1 class="display-6">The world's first mobile app <span class="main-color">built for listening with users in mind</span></h1>
</div>
<div class="row align-items-center mt-20">
  <div class="col-lg-6 col-sm-12 mt-20">
    <div class="lead">What you get with Peech?</div>
  </div>
</div> -->

  <div class="row mt-32 w-100">
    <h1 class="display-6" i18n="@@peopleOftenAsk">People often ask</h1>
  </div>
  <div class="col-12 mt-24">
    <mat-accordion class="tagus-basic-expansion mb-20">
      @for (faq of faqs; track faq.question) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ faq.question }}</mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{ faq.answer }}</p>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>

  <!-- <h1 class="display-6 mt-20">Try <span class="main-color">Peech Premium</span> with introductory discount</h1>
<div class="subscription-info">
  <div class="subscription-text">Enjoy full access for the selected period. Love it and keep investing in yourself, or simply cancel before the period ends so you won't be charged repeatedly.</div>
</div>

<button mat-flat-button class="tagus pay-button" (click)="payButtonClicked()">{{purchaseButtonTitle}}</button> -->

  <h1 class="display-6 mt-32 w-100" i18n="@@dontJustTakeWord">Don't Just Take Our Word for It</h1>

  <div class="d-flex flex-wrap justify-content-center w-100 mt-20 gap-8">
    @for (review of reviews; track review) {
      <app-user-review class="flex-grow-1" [data]="review"></app-user-review>
    }
  </div>

  <button mat-flat-button class="tagus pay-button pulsing" (click)="payButtonClicked()">
    {{ purchaseButtonTitle }}
  </button>

  <h1 class="display-6 mt-32 w-100" [innerHTML]="communityTitle"></h1>

  <div class="d-flex flex-wrap justify-content-center w-100 mt-20 gap-16">
    <div class="stat d-flex align-items-center">
      <div class="stats-icon"></div>
      <div class="d-flex flex-column">
        <div class="stats-title fs-20">
          <span class="highlight">10 </span> <ng-container i18n="@@million">Million</ng-container>
        </div>
        <div class="stats-text" i18n="@@usersAllPlatforms">Users on all platforms</div>
      </div>
    </div>
    <div class="stat d-flex align-items-center">
      <div class="stats-icon"></div>
      <div class="d-flex flex-column">
        <div class="stats-title fs-20">
          <span class="highlight">4.8 </span> <ng-container i18n="@@stars">Stars</ng-container>
        </div>
        <div class="stats-text" i18n="@@avgRatingsAppStore">Average ratings on App Store</div>
      </div>
    </div>
    <div class="stat d-flex align-items-center">
      <div class="stats-icon"></div>
      <div class="d-flex flex-column">
        <div class="stats-title fs-20" [innerHTML]="peechMembersPercentStat"></div>
        <div class="stats-text" i18n="@@createBetterHabit">Create a better reading habit*</div>
      </div>
    </div>
  </div>

  <h4 class="mt-32" i18n="@@chooseYourPlan">Choose your plan:</h4>

  <div class="col-12 mt-16">
    <app-checkout
      [(selectedProduct)]="selectedProduct"
      #checkout
      [placement]="placement"
      [email]="email"
      [name]="name"
      [stripeCustomerId]="stripeCustomerId"
      [isDisclaimerShown]="false"
      [isSafeCheckoutNoteShown]="false"
      [insufficientFundsAction]="getInsufficientFundsAction()"
      [moneyBackGuaranteeMode]="'large'"
      (canceledPurchase)="onPurchaseCanceled()"
      (purchaseButtonTitle)="handlePurchaseButtonTitle($event)"
      (discountTitle)="handleDiscountTitle($event)"
    >
    </app-checkout>
  </div>

  @if (selectedProduct) {
    <div class="muted-color fs-12 mt-20" i18n="@@subscriptionDisclaimer">
      We've automatically applied discount to your first subscription price. You will be charged
      {{ selectedProduct.priceLabel }}. Please note that your subscription will be automatically
      renewed at full price of {{ selectedProduct.fullPriceLabel }} at the end of chosen
      subscription term. Terms and Conditions apply. If you want to manage your subscription, you
      may do so via your personal account.
    </div>
  }

  <div class="muted-color fs-12 mt-20" i18n="@@basedOnSurveyData">
    *Based on survey data from Peech users
  </div>

  <div class="muted-color mt-20 mb-32 fs-12">
    <a target="_blank" href="https://www.getpeech.com/terms" i18n="@@termsConditions"
      >Terms & Conditions</a
    >
    &nbsp;<span i18n="@@and">and</span>&nbsp;
    <a target="_blank" href="https://www.getpeech.com/privacy" i18n="@@privacyPolicy"
      >Privacy Policy</a
    >
  </div>
</div>
